import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var StringText = props => {
  var {
    Str: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Str');
  return null;
};
StringText.displayName = 'JVR.StringText';